import type React from "react";
import { cn } from "src/shadcn/lib/utils";
import {
  Sidebar as ShadcnSidebar,
  SidebarContent as ShadcnSidebarContent,
  SidebarFooter as ShadcnSidebarFooter,
  SidebarGroup as ShadcnSidebarGroup,
  SidebarGroupAction as ShadcnSidebarGroupAction,
  SidebarGroupContent as ShadcnSidebarGroupContent,
  SidebarGroupLabel as ShadcnSidebarGroupLabel,
  SidebarHeader as ShadcnSidebarHeader,
  SidebarInput as ShadcnSidebarInput,
  SidebarInset as ShadcnSidebarInset,
  SidebarMenu as ShadcnSidebarMenu,
  SidebarMenuAction as ShadcnSidebarMenuAction,
  SidebarMenuBadge as ShadcnSidebarMenuBadge,
  SidebarMenuButton as ShadcnSidebarMenuButton,
  SidebarMenuItem as ShadcnSidebarMenuItem,
  SidebarMenuSkeleton as ShadcnSidebarMenuSkeleton,
  SidebarMenuSub as ShadcnSidebarMenuSub,
  SidebarMenuSubButton as ShadcnSidebarMenuSubButton,
  SidebarMenuSubItem as ShadcnSidebarMenuSubItem,
  SidebarProvider as ShadcnSidebarProvider,
  SidebarRail as ShadcnSidebarRail,
  SidebarSeparator as ShadcnSidebarSeparator,
  SidebarTrigger as ShadcnSidebarTrigger,
  useSidebar,
} from "src/shadcn/components/sidebar";

const Sidebar = ({
  className,
  ...props
}: React.ComponentProps<typeof ShadcnSidebar>) => (
  <ShadcnSidebar className={cn("border-border", className)} {...props} />
);

const SidebarContent = (
  props: React.ComponentProps<typeof ShadcnSidebarContent>
) => <ShadcnSidebarContent {...props} />;

const SidebarFooter = (
  props: React.ComponentProps<typeof ShadcnSidebarFooter>
) => <ShadcnSidebarFooter {...props} />;

const SidebarGroup = (
  props: React.ComponentProps<typeof ShadcnSidebarGroup>
) => <ShadcnSidebarGroup {...props} />;

const SidebarGroupAction = ({
  className,
  ...props
}: React.ComponentProps<typeof ShadcnSidebarGroupAction>) => (
  <ShadcnSidebarGroupAction
    className={cn(
      "cursor-pointer disabled:cursor-not-allowed aria-disabled:cursor-not-allowed",
      className
    )}
    {...props}
  />
);

const SidebarGroupContent = (
  props: React.ComponentProps<typeof ShadcnSidebarGroupContent>
) => <ShadcnSidebarGroupContent {...props} />;

const SidebarGroupLabel = (
  props: React.ComponentProps<typeof ShadcnSidebarGroupLabel>
) => <ShadcnSidebarGroupLabel {...props} />;

const SidebarHeader = (
  props: React.ComponentProps<typeof ShadcnSidebarHeader>
) => <ShadcnSidebarHeader {...props} />;

const SidebarInput = (
  props: React.ComponentProps<typeof ShadcnSidebarInput>
) => <ShadcnSidebarInput {...props} />;

const SidebarInset = (
  props: React.ComponentProps<typeof ShadcnSidebarInset>
) => <ShadcnSidebarInset {...props} />;

const SidebarMenu = (props: React.ComponentProps<typeof ShadcnSidebarMenu>) => (
  <ShadcnSidebarMenu {...props} />
);

const SidebarMenuAction = ({
  className,
  ...props
}: React.ComponentProps<typeof ShadcnSidebarMenuAction>) => (
  <ShadcnSidebarMenuAction
    className={cn(
      "cursor-pointer disabled:cursor-not-allowed aria-disabled:cursor-not-allowed",
      className
    )}
    {...props}
  />
);

const SidebarMenuBadge = (
  props: React.ComponentProps<typeof ShadcnSidebarMenuBadge>
) => <ShadcnSidebarMenuBadge {...props} />;

const SidebarMenuButton = ({
  className,
  ...props
}: React.ComponentProps<typeof ShadcnSidebarMenuButton>) => (
  <ShadcnSidebarMenuButton
    className={cn(
      "cursor-pointer disabled:cursor-not-allowed aria-disabled:cursor-not-allowed",
      className
    )}
    {...props}
  />
);

const SidebarMenuItem = (
  props: React.ComponentProps<typeof ShadcnSidebarMenuItem>
) => <ShadcnSidebarMenuItem {...props} />;

const SidebarMenuSkeleton = (
  props: React.ComponentProps<typeof ShadcnSidebarMenuSkeleton>
) => <ShadcnSidebarMenuSkeleton {...props} />;

const SidebarMenuSub = (
  props: React.ComponentProps<typeof ShadcnSidebarMenuSub>
) => <ShadcnSidebarMenuSub {...props} />;

const SidebarMenuSubButton = ({
  className,
  ...props
}: React.ComponentProps<typeof ShadcnSidebarMenuSubButton>) => (
  <ShadcnSidebarMenuSubButton
    className={cn(
      "cursor-pointer disabled:cursor-not-allowed aria-disabled:cursor-not-allowed",
      className
    )}
    {...props}
  />
);

const SidebarMenuSubItem = (
  props: React.ComponentProps<typeof ShadcnSidebarMenuSubItem>
) => <ShadcnSidebarMenuSubItem {...props} />;

const SidebarProvider = (
  props: React.ComponentProps<typeof ShadcnSidebarProvider>
) => <ShadcnSidebarProvider {...props} />;

const SidebarRail = (props: React.ComponentProps<typeof ShadcnSidebarRail>) => (
  <ShadcnSidebarRail {...props} />
);

const SidebarSeparator = (
  props: React.ComponentProps<typeof ShadcnSidebarSeparator>
) => <ShadcnSidebarSeparator {...props} />;

const SidebarTrigger = ({
  className,
  ...props
}: React.ComponentProps<typeof ShadcnSidebarTrigger>) => (
  <ShadcnSidebarTrigger
    className={cn("cursor-pointer disabled:cursor-not-allowed", className)}
    {...props}
  />
);

export {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupAction,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarInput,
  SidebarInset,
  SidebarMenu,
  SidebarMenuAction,
  SidebarMenuBadge,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSkeleton,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
  SidebarProvider,
  SidebarRail,
  SidebarSeparator,
  SidebarTrigger,
  useSidebar,
};
